import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getBaseUrl, getCurrentUser } from "../reducers";
import { stopImpersonation } from "requesters/impersonationRequester";

const ImpersonationBanner = () => {
  const impersonating = useSelector(state => state.config.impersonating)
  const currentUser = useSelector(getCurrentUser)
  const baseUrl = useSelector(getBaseUrl)
  const [stopping, setStopping] = useState(false)

  useEffect(() => {
    document.body.classList.toggle("impersonating-active", Boolean(impersonating))
    return () => document.body.classList.remove("impersonating-active")
  }, [impersonating])

  if (!impersonating || !currentUser) return null

  const { name, email } = currentUser.attributes || {}

  const handleStop = () => {
    if (stopping) return
    setStopping(true)
    stopImpersonation(baseUrl)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          window.location.assign("/")
          return
        }
        setStopping(false)
      })
      .catch(() => setStopping(false))
  }

  return (
    <div className="impersonation-banner" role="status">
      <span>
        {`You are impersonating ${name} (${email})`}
      </span>
      <button type="button" onClick={handleStop} disabled={stopping}>
        Stop Impersonating
      </button>
    </div>
  )
}

export default ImpersonationBanner
